import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserAuthorization from './user-authorization.reducer';

export const selectUserAuthorizationState =
    createFeatureSelector<fromUserAuthorization.State>(
        fromUserAuthorization.userAuthorizationsFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromUserAuthorization.adapter.getSelectors(selectUserAuthorizationState);

export const getPendingAuthorizations = createSelector(
    selectUserAuthorizationState,
    x => x.pendingAuthorizations
);
export const getUserAuthorizationErrors = createSelector(
    selectUserAuthorizationState,
    x => x.errors
);
export const getPendingAuthorizationCount = createSelector(
    selectUserAuthorizationState,
    x => x.pendingCount
);
